
export const copyToClipboard = async (text: string, showNotification = true) => {
  const { $functions } = useNuxtApp() 
  try {
    // Ensure text is plain text only (no formatting/styling)
    const plainText = typeof text === 'string' ? text : String(text);
    
    if (navigator.clipboard) {
      // Modern Clipboard API - use writeText to ensure plain text
      await navigator.clipboard.writeText(plainText);
      if (showNotification) {
        $functions.notify.info({
          text: 'Copied to clipboard'
        });
      }
    } else {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      
      if (showNotification) {
        $functions.notify.info({
          text: 'Copied to clipboard'
        });
      }
    }
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    $functions.notify.error({
      text: 'Failed to copy to clipboard'
    });
  }
};

export const handleCopyAsPlainText = (event: ClipboardEvent, stripHtmlFn: (html: string) => string) => {
  // ดักจับ copy event และแปลง HTML เป็น plain text
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return;

  // ดึง HTML ที่ถูกเลือก
  const range = selection.getRangeAt(0);
  const container = document.createElement('div');
  container.appendChild(range.cloneContents());

  // แปลง HTML เป็น plain text
  const plainText = stripHtmlFn(container.innerHTML);

  // ใส่ plain text ลง clipboard แทนที่ HTML
  event.preventDefault();
  event.clipboardData?.setData('text/plain', plainText);
};
